<template>
  <div class="myTable">
    <div class="searchNav">
      <div class="search-form">
        <div class="search-items">
          <div class="search-item">
            <span class="label">手机号码：</span>
            <el-input v-model="searchInfo.phone" clearable placeholder="请输入手机号"></el-input>
          </div>
          <div class="search-item">
            <span class="label">用户昵称：</span>
            <el-input v-model="searchInfo.nickname" clearable placeholder="请输入昵称"></el-input>
          </div>
          <div class="search-item">
            <span class="label">用户状态：</span>
            <el-select v-model="searchInfo.status" clearable @change="search" placeholder="请选择">
              <el-option v-for="(item, i) in statusList" :key="i" :label="item.value" :value="item.status"></el-option>
            </el-select>
          </div>
          <div class="search-item">
            <span class="label">所在省份：</span>
            <el-input v-model="searchInfo.province" clearable placeholder="请输入省份"></el-input>
          </div>
          <div class="search-item">
            <span class="label">所在城市：</span>
            <el-input v-model="searchInfo.city" clearable placeholder="请输入城市"></el-input>
          </div>

          <div class="search-item date-picker">
            <span class="label">注册时间：</span>
            <el-date-picker v-model="searchDateArr" type="daterange" align="right" unlink-panels range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
              :picker-options="pickerOptions">
            </el-date-picker>
          </div>
        </div>
      </div>
      <div class="search-btn">
        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </div>
    </div>
    <div class="tableStyle">
      <el-table v-loading="loading" :data="tableData" style="width: 100%;" :row-class-name="tableRowClassName"  max-height="600px"  @row-dblclick="handleRowDblClick" >
        <el-table-column
                type="index"
                width="50">
        </el-table-column>
        <el-table-column label="头像" width="80">
          <template slot-scope="scope">
            <el-avatar :size="40" :src="scope.row.avatar" icon="el-icon-user-solid"></el-avatar>
          </template>
        </el-table-column>
        <el-table-column prop="phone" label="手机号码" width="120" ></el-table-column>
        <el-table-column prop="nickname" label="昵称" width="120" ></el-table-column>
        <el-table-column label="地区" width="150">
          <template slot-scope="scope">
            <span>{{ [scope.row.province, scope.row.city, scope.row.district].filter(Boolean).join('') || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="fansCount" label="粉丝数" width="80">
          <template slot-scope="scope">
            <span style="color: #409EFF; font-weight: 500;">{{ scope.row.fansCount }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="followCount" label="关注数" width="80">
          <template slot-scope="scope">
            <span style="color: #67C23A; font-weight: 500;">{{ scope.row.followCount }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="productCount" label="商品数" width="80">
          <template slot-scope="scope">
            <span style="color: #E6A23C; font-weight: 500;">{{ scope.row.productCount }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="creditScore" label="信用分" width="80">
          <template slot-scope="scope">
            <span :style="getCreditScoreStyle(scope.row.creditScore)">{{ scope.row.creditScore }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="80">
          <template slot-scope="scope"  >
            <el-tag :type="getStatusTagType1(scope.row.status)">
              {{ scope.row.status | showStatus }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="注册时间" width="160">
          <template slot-scope="scope" >
            {{ scope.row.createTime }}
          </template>
        </el-table-column>
        <el-table-column prop="updateTime" label="最后登录" width="160">
          <template slot-scope="scope">
            {{ scope.row.updateTime || '--' }}
          </template>
        </el-table-column>

        <el-table-column
                fixed="right"
                label="操作"
                width="110">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="moreInfo(scope.row)">详情</el-button>
            <span>
              <el-button type="text" size="small" v-if="scope.row.status === 1" @click="confirmChangeStatus(scope.row, 2)" style="color: #F56C6C;">冻结</el-button>
              <el-button type="text" size="small" v-else-if="scope.row.status === 2" @click="confirmChangeStatus(scope.row, 1)" style="color: #67C23A;">解冻</el-button>
            </span>
          </template>
        </el-table-column>
        <!-- 自定义空数据展示 -->
        <template slot="empty">
          <div class="empty-container">
            <el-empty :image-size="200"></el-empty>
          </div>
        </template>
      </el-table>
      <el-pagination style="text-align: right;"
                     @size-change="handleSizeChange"
                     @current-change="handleCurrentChange"
                     :current-page.sync="currentPage"
                     :page-size="searchInfo.pageSize"
                     :page-sizes="[10,20, 50, 100]"
                     layout="sizes, prev, pager, next ,total"
                     :total="total">
      </el-pagination>
    </div>

    <!-- 用户详情对话框 -->
    <user-detail-dialog 
      :visible.sync="moreInfoDialogVisible" 
      :user-data="addInfo">
    </user-detail-dialog>

  </div>

</template>

<script>
  import {axios} from "../../config/axios";
  import UserDetailDialog from '../common/user-detail-dialog.vue';
  
  export default {
    name: "white-list",
    components: {
      UserDetailDialog
    },
    data () {
      const vm = this; // 保存组件实例的引用
      return {
        dialogTitle:'新增客户',
        total:1,
        tableData: [],
        searchDateArr: [],
        loading: false,
        tableLoading: false,
        moreInfoDialogVisible: false,
        deviceBindingDialogVisibleList: false,
        deviceBindingDialogVisible: false,
        currentPage:1,
        currentPhoneNumber:'',
        addInfo:{},
        searchInfo:{
          phone:'',
          nickname:'',
          status:'',
          province:'',
          city:'',
          searchDate:'',
          pageNumber:1,
          pageSize:50,
        },
        genderList:[{"status":"","value":"全部"},{"status":"0","value":"未知"},{"status":"1","value":"男"},{"status":"2","value":"女"}],
        statusList:[{"status":"","value":"全部"},{"status":"1","value":"正常"},{"status":"2","value":"冻结"},{"status":"3","value":"注销"}],
        vipList:[{"status":"","value":"全部"},{"status":"0","value":"普通用户"},{"status":"1","value":"VIP用户"}],
        customerContactsList:[{"name":"","phone":"","post":""}],
        rules: {
          name: [
            { required: true, message: '请输入客户名称', trigger: 'blur' }
          ],
          phone: [
            { required: false, message: '请输入电话', trigger: 'blur' },
            { validator: (rule, value, callback) => {
                if (!value) {
                  callback(new Error('请输入电话'));
                } else if (!vm.validatePhoneNumber(value)) {
                  callback(new Error('输入的固定电话格式有误，请修改！'));
                } else {
                  callback();
                }
              }, trigger: 'blur' }
          ],
          address: [
            { required: true, message: '请输入地址', trigger: 'blur' }
          ],
        },
        pickerOptions: {
          shortcuts: [{
            text: '今天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              //start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          },
            {
              text: '最近一周',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                picker.$emit('pick', [start, end]);
              }
            }]
        },

      }
    },
    watch: {
      'searchInfo.phone'(newVal,oldVal){
        console.info(newVal,oldVal)
        if ("" == newVal){
          this.pageInfo();
        }
      },
      'searchInfo.nickname'(newVal,oldVal){
        console.info(newVal,oldVal)
        if ("" == newVal){
          this.pageInfo();
        }
      },
      'searchInfo.province'(newVal,oldVal){
        console.info(newVal,oldVal)
        if ("" == newVal){
          this.pageInfo();
        }
      },
      'searchInfo.city'(newVal,oldVal){
        console.info(newVal,oldVal)
        if ("" == newVal){
          this.pageInfo();
        }
      },
      'searchDateArr'(newVal,oldVal){
        if (null == newVal){
          this.searchInfo.startDate = "";
          this.searchInfo.endDate = "";
          this.pageInfo();
        }
      },
    },
    created: function () {
      this.pageInfo();
    },
    methods:{
      search(){
        this.pageInfo();
      },
      addRow(){
        this.customerContactsList.push({"name":"","phone":"","post":""});
      },
      removeRow(index){
        this.customerContactsList.splice(index, 1);
      },
          // 获取信用分样式
      getCreditScoreStyle(score) {
        if (score >= 90) {
          return { color: '#67C23A', fontWeight: 'bold' }; // 绿色
        } else if (score >= 70) {
          return { color: '#E6A23C', fontWeight: 'bold' }; // 橙色
        } else {
          return { color: '#F56C6C', fontWeight: 'bold' }; // 红色
        }
      },
      getStatusTagType1(status) {
        const typeMap = {
          2: 'warning',  // 未审核
          1: 'success',     // 草稿
          0: 'info'
        };
        return typeMap[status] || 'info';
      },
      handleCurrentChange(val) {
        this.currentPage = val;
        this.searchInfo.pageNumber = val ;
        this.pageInfo();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.currentPage = 0;
        this.searchInfo.pageSize = val ;
        this.pageInfo();
      },
      validate(){

        let flag = true;
        let msg  = "";
        return {code:flag,msg:msg}
      },
      // 确认状态变更
      confirmChangeStatus(obj, newStatus){
        const statusText = newStatus === 1 ? '解冻' : '冻结';
        this.$confirm(`确定要${statusText}用户 ${obj.nickname}(${obj.phone}) 吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.changeUserStatus(obj.id, newStatus);
        }).catch(() => {
          this.$message({
            type: 'info',
            message: `已取消${statusText}`
          });
        });
      },
      // 确认VIP升级
      confirmVipUpgrade(obj){
        this.$confirm(`确定要将用户 ${obj.nickname}(${obj.phone}) 升级为VIP吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.changeUserVip(obj.id, 1);
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消升级'
          });
        });
      },
      // 确认VIP降级
      confirmVipDowngrade(obj){
        this.$confirm(`确定要取消用户 ${obj.nickname}(${obj.phone}) 的VIP权限吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.changeUserVip(obj.id, 0);
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          });
        });
      },
      moreInfo(obj){
        this.addInfo =JSON.parse(JSON.stringify(obj));
        this.moreInfoDialogVisible = true;
        //.getContactsLists(this.addInfo.id);
      },
      handleRowDblClick(row, column, event) {
        this.addInfo =JSON.parse(JSON.stringify(row));
        this.moreInfoDialogVisible = true;
        //this.getContactsLists(this.addInfo.id);
      },
      // 修改用户状态
      changeUserStatus(id, status){
        axios.put("/app/user/status", {id: id, status: status}).then(res => {
          if (res.code !== 200){
            this.$message.error(res.message || '操作失败');
            return;
          }
          this.$message.success('状态修改成功');
          this.pageInfo();
        }).catch(err =>{
          console.log(err);
          this.$message.error('操作失败');
        })
      },
      // 修改用户VIP状态
      changeUserVip(id, isVip){
        axios.put("/app/user/vip", {id: id, isVip: isVip}).then(res => {
          if (res.code !== 200){
            this.$message.error(res.message || '操作失败');
            return;
          }
          this.$message.success('VIP状态修改成功');
          this.pageInfo();
        }).catch(err =>{
          console.log(err);
          this.$message.error('操作失败');
        })
      },
      pageInfo(){
        if (this.searchDateArr && this.searchDateArr.length === 2) {
          this.searchInfo.startDate = this.searchDateArr[0];
          this.searchInfo.endDate = this.searchDateArr[1];
        }
        if (this.loading)  return; // 防止重复提交
        this.loading=true;
        axios.get('/app/user/list',{
          params: this.searchInfo
        }).then(result => {
          this.loading=false;
          if (result.code !== 200){
            console.log(result);
          }
          let page = result.data;

          this.total = page.total;
          this.tableData = page.list;
        }).catch(err => {
          console.log(err);
          this.loading=false;
        });
      },

    },filters: {
      // 显示用户状态
      showStatus(val){
        switch(val) {
          case 1: return "正常";
          case 2: return "冻结";
          case 3: return "注销";
          default: return "--";
        }
      },
    }
  }
</script>
<style lang="less" scoped>
  .addInfoStyle div{
    line-height: 4;
    .el-input{
      margin-right: 15px;
      width: 200px;
    }
  }
  /deep/ #contentStyle .el-form-item__content{
    margin-left:0 !important;
  }
  .connectTitleStyle{
    display: flex;
    justify-content: space-between;
    background: #f6f8fc;
    margin-left: 15px;
  }

  /deep/ #connectInfoStyle .el-table{
    .el-table__body-wrapper{
      height: auto; overflow-y: auto;
    }
  }

  .searchNav {
    padding: 16px 16px 0 16px;
    background: #fff;
    border-radius: 4px;
    display: flex;
    align-items: flex-start;

    .search-form {
      flex: 1;
      padding-right: 16px;

      .search-items {
        display: flex;
        flex-wrap: wrap;
        margin: 0 -8px;

        .search-item {
          display: flex;
          align-items: center;
          margin-bottom: 8px;
          min-width: fit-content;

          .label {
            white-space: nowrap;
            color: #606266;
            font-size: 12px;
          }

          .el-input {
            width: 180px !important;
            /deep/ .el-input__inner {
              height: 32px;
              line-height: 32px;
            }
          }

          .el-select {
            width: 180px !important;
            /deep/ .el-input__inner {
              height: 32px;
              line-height: 32px;
            }
          }

          &.date-picker {
            .el-date-editor {
              width: 280px !important;
              /deep/ .el-input__inner {
                height: 32px;
                line-height: 32px;
              }
            }
          }
        }
      }
    }

    .search-btn {
      padding-top: 0;
      .el-button {
        height: 32px;
        line-height: 32px;
        padding: 0 20px;
      }
    }
  }

  @media screen and (max-width: 768px) {
    .searchNav {
      flex-direction: column;
      padding: 12px;

      .search-form {
        width: 100%;
        padding-right: 0;

        .search-items {
          .search-item {
            width: 100%;

            .el-input, .el-select, .el-date-editor {
              width: 100% !important;
            }
          }
        }
      }

      .search-btn {
        width: 100%;
        margin-top: 16px;
        justify-content: center;
      }
    }
  }
  /deep/ .el-date-editor .el-range-separator {
    color: #606266 !important;
  }


</style>
